import { ADMIN_CRON_PRESETS } from "../../components/CronExpressionBuilder";

export const TASK_SCHEDULER_TYPES = [
    { value: "FACEBOOK_IMAGE_POST", label: "Facebook image post" },
    { value: "INSTAGRAM_IMAGE_POST", label: "Instagram image post" },
    {
        value: "WORD_WHEEL_FACEBOOK_POST",
        label: "Word Wheel → Facebook + Instagram",
    },
    {
        value: "PROMOTION_EMAIL",
        label: "Promotion email (READY_TO_SENT)",
    },
    {
        value: "WEEKLY_EMAIL",
        label: "Weekly puzzle email",
    },
];

export const DEFAULT_TASK_SCHEDULER_CRON = "0 0 14 * * ?";

export const TASK_SCHEDULER_CRON_PRESETS = ADMIN_CRON_PRESETS;

/** Which image to post when the job auto-picks a story (no storyId / imageUrl). See scheduler-rest-api.md */
export const IMAGE_SOURCE_OPTIONS = [
    {
        value: "random",
        label: "Random (jigsaw or sliding)",
        description:
            "Post a published jigsaw or sliding image from the standalone pack. Falls back to the illustration only if neither puzzle image exists.",
    },
    {
        value: "story",
        label: "Story illustration only",
        description: "Use the story’s main illustration only. Fails if the story has no image URL.",
    },
    {
        value: "jigsaw",
        label: "Jigsaw only",
        description: "Use the published jigsaw image for that story. Fails if no jigsaw row has a URL.",
    },
    {
        value: "sliding",
        label: "Sliding puzzle only",
        description: "Use the published sliding puzzle image. Fails if no sliding row has a URL.",
    },
];

/** @param {string} type */
const DEFAULT_IMAGE_POST_PAYLOAD = { imageSource: "random", fullSizeImage: true };

export function getDefaultTaskSchedulerPayload(type) {
    switch (type) {
        case "INSTAGRAM_IMAGE_POST":
        case "FACEBOOK_IMAGE_POST":
            return { ...DEFAULT_IMAGE_POST_PAYLOAD };
        case "WORD_WHEEL_FACEBOOK_POST":
            return { language: "english" };
        case "PROMOTION_EMAIL":
        case "WEEKLY_EMAIL":
            return {};
        default:
            return {};
    }
}

/** @param {Record<string, unknown>} payload */
function buildImageSourcePayload(payload) {
    return {
        imageSource:
            typeof payload.imageSource === "string" && payload.imageSource.trim()
                ? payload.imageSource.trim()
                : "random",
        fullSizeImage: Boolean(payload.fullSizeImage),
    };
}

/**
 * @param {string} type
 * @param {unknown} payload
 */
export function normalizeTaskSchedulerPayload(type, payload) {
    const defaults = getDefaultTaskSchedulerPayload(type);
    if (payload && typeof payload === "object" && !Array.isArray(payload)) {
        return { ...defaults, ...payload };
    }
    return { ...defaults };
}

/**
 * @param {string} type
 * @param {Record<string, unknown>} payload
 */
export function buildTaskSchedulerPayloadForApi(type, payload) {
    if (type === "INSTAGRAM_IMAGE_POST") {
        return buildImageSourcePayload(payload);
    }
    if (type === "FACEBOOK_IMAGE_POST") {
        const out = buildImageSourcePayload(payload);
        if (typeof payload.storyId === "string" && payload.storyId.trim()) {
            out.storyId = payload.storyId.trim();
        }
        if (typeof payload.imageUrl === "string" && payload.imageUrl.trim()) {
            out.imageUrl = payload.imageUrl.trim();
        }
        if (typeof payload.message === "string" && payload.message.trim()) {
            out.message = payload.message.trim();
        }
        if (payload.skipAutoCaption === true) {
            out.skipAutoCaption = true;
        }
        return out;
    }
    if (type === "WORD_WHEEL_FACEBOOK_POST") {
        const out = {};
        if (typeof payload.language === "string" && payload.language.trim()) {
            out.language = payload.language.trim();
        } else {
            out.language = "english";
        }
        return out;
    }
    if (type === "PROMOTION_EMAIL" || type === "WEEKLY_EMAIL") {
        return {};
    }
    return payload;
}
